import React, { Fragment, useEffect, } from 'react';
import { Button, } from 'reactstrap';
import { isEmpty, groupBy, get, pick, omit, uniqBy, keyBy, } from 'lodash';
import { toast, } from 'react-toastify';
import { useCounter, useToggle, } from 'react-use';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import numeral from 'numeral';

import firebase, { functions } from '../../firebase';
import { idWithTenant, } from '../../shared/util';
import { boxSizes, } from '../../shared/config';
import { adminFields, } from '../../shared/models/product';
import { cmSizes, } from '../../shared/models/amazonProduct';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import useDocumentSubscription from '../hooks/useDocumentSubscription';
import useQueryParams from '../hooks/useQueryParams';
import AdminPage from '../hocs/AdminPage';
import ModelFormModal from '../modals/ModelFormModal';
import QuerySelector from '../QuerySelector';
import EditButton from '../EditButton';
import ProgressButton from '../ProgressButton';
import ModalButton from '../ModalButton';

const { keys, entries } = Object;
const db = firebase.firestore();
const tenantsRef = db.collection('tenants');
const postAmazonProducts = functions.httpsCallable('postAmazonProducts');
const checkFnsku = functions.httpsCallable('checkFnsku');

export default AdminPage(function AdminProducts (props) {
  const { tenantId: [tenantId] = [], } = useQueryParams();
  const tenants = useCollectionSubscription(tenantsRef.orderBy('createdAt'));
  const tenantOptions = tenants.map(_ => ({ label: `[${_.id}] ${_.name}`, value: _.id }));
  const tenant = useDocumentSubscription(tenantId && tenantsRef.doc(tenantId), [tenantId]);
  const products = useCollectionSubscription(tenant && tenant.ref.collection('products').orderBy('createdAt', 'desc'), [tenant]);

  return (
    <div className="admin-receivingRequests container-fluid">
      <div className="p-4 bg-white my-4">
        <div className="d-flex justify-content-center mb-3">
          <h4>商品管理</h4>
        </div>
        <div className="d-flex justify-content-between align-items-end mb-3">
          <div className="flex-fill d-flex">
            <div style={{ width: 300 }} className="ml-2">
              <QuerySelector className="w-100" paramName="tenantId" options={tenantOptions} label="テナント選択" />
            </div>
          </div>
        </div>
        <div className="mt-4 overflow-scroll position-relative" style={{ zIndex: 0 }}>
          {
            products.length > 0 ? (
              <table className="table sticky-table table-bordered">
                <thead className="thead-light text-center">
                  <tr className="text-nowrap">
                    <th style={{ minWidth: 150 }}>ID</th>
                    <th style={{ minWidth: 150 }}>SKU</th>
                    <th style={{ minWidth: 150 }}>FNSKU</th>
                    <th style={{ minWidth: 150 }}>ASIN</th>
                    <th style={{ minWidth: 200 }}>JAN</th>
                    <th style={{ minWidth: 200 }}>商品名</th>
                    <th style={{ minWidth: 100 }}>在庫数</th>
                    <th style={{ minWidth: 100 }}>販売不可数</th>
                    <th style={{ minWidth: 200 }}>FNSKUエラー</th>
                    <th style={{ minWidth: 200 }}>サイズ</th>
                    <th style={{ minWidth: 200 }}>保管サイズ</th>
                    <th style={{ minWidth: 200 }}>期限あり</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {
                    products.map((product) => {
                      const { id, ref, isAmazonProduct, name, sku, fnsku, asin, goodInventoryIds = [], ngInventoryIds = [], fnskuError, amazonProduct, shippingSize, storageSize, hasExpiration = false, barcodeInfo, } = product;
                      const onClickPost = async () => {
                        await postAmazonProducts({
                          tenantId: tenant.id,
                          products: [omit(product, ['ref'])],
                        });
                      };
                      const onClickCheckFnsku = async () => {
                        await checkFnsku({ tenantId, productId: id });
                      };

                      return (
                        <tr key={id}>
                          <td>
                            {idWithTenant(ref)}
                          </td>
                          <td>
                            {sku}
                          </td>
                          <td>
                            {fnsku}
                          </td>
                          <td>
                            {asin}
                          </td>
                          <td>
                            {barcodeInfo}
                          </td>
                          <td>
                            {name}
                          </td>
                          <td className="text-right">
                            {numeral(goodInventoryIds.length).format()}
                          </td>
                          <td className="text-right">
                            {numeral(ngInventoryIds.length).format()}
                          </td>
                          <td>
                            {fnskuError}
                          </td>
                          <td>
                            {
                              shippingSize ? (
                                boxSizes[shippingSize]?.label
                              ) : (
                                amazonProduct && cmSizes(amazonProduct).map(_ => Math.round(_) + 'cm').join(' x ')
                              )
                            }
                          </td>
                          <td>
                            {boxSizes[storageSize]?.label}
                          </td>
                          <td>
                            {hasExpiration && '期限あり'}
                          </td>
                          <td className="text-right text-nowrap">
                            <div className="d-flex gap-1">
                              <ProgressButton process={onClickCheckFnsku} className={classnames({ invisible: (!isAmazonProduct || [goodInventoryIds, ngInventoryIds].some(_ => _.length > 0)) })}>
                                FNSKU再取得
                              </ProgressButton>
                              <ProgressButton label="出品" process={onClickPost} className={classnames({ invisible: !isAmazonProduct })} />
                              <EditButton itemRef={ref} FormModal={ModelFormModal} formProps={{ title: '商品 編集', fields: adminFields, }} />
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  }
                </tbody>
              </table>
            ) : (
              <div>
                No Data
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
});
